import React from 'react';
import { MotorFunnelState } from 'scenes/motor/types';
import { getCampaign } from 'scenes/motor/selectors';
import { campaignTCLink } from 'scenes/common/helpers/contacts';
import { suppressOfferApplied } from 'scenes/motor/helpers/campaign';

const marketingDisclaimer: JSX.Element = (
  <p>
    <strong>Don&apos;t miss out on your chance to win!</strong> Select{' '}
    <strong>Yes</strong> in order to go into our &lsquo;win a car&rsquo;
    competition. Eligible for new Coles Comprehensive Car policies only.{' '}
    <a href={campaignTCLink()} target="_blank" rel="noopener noreferrer">
      View terms and conditions.
    </a>
  </p>
);

export const getActiveCampaignDisclaimer = (
  funnelState: MotorFunnelState
): JSX.Element | undefined =>
  getCampaign(funnelState) && suppressOfferApplied
    ? marketingDisclaimer
    : undefined;
